import * as React from "react";
import "./Homepage.css";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../services/imageBaseApi";
// import Smallbutton from "../../component/button/Smallbutton";

const Ncomponent = ({ setHoveredLetter, isMobile, data }) => {
  const router = useNavigate();
  console.log(data)
  return (
    <>
      {!isMobile ? (<div className="d-flex align-items-end  " >
        <img
          src={imageBaseApi + data?.[0]?.media?.url}
          style={{ width: "50%", marginRight: "6rem", transform: "translateY(-23rem)", }}
          alt="New Zealand"

        />

        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 832.64 386.69"
          width="150%"
          style={{ flexShrink: "0", }}

        >
          <rect
            x="0"
            y="0"
            width="832.64"
            height="196.69"
            fill="transparent"
            onMouseEnter={() => setHoveredLetter("N")}
            onMouseLeave={() => setHoveredLetter(null)}
          />
          <g transform="translate(0, 5)">

            {/* Large Heading */}
            <foreignObject
              x="0.94"
              y="-8"
              width="500"    // set your desired fixed width
              height="200"   // set enough height for all lines
            >
              <div
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  fontFamily: "Proxima Nova Black, Proxima Nova",
                  fontSize: "52px",
                  fontWeight: 800,
                  color: data?.[0]?.titleColor,
                  lineHeight: "1",
                  wordWrap: "break-word",
                }}
              >

                {data?.[0]?.title?.split("/n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}



              </div>
            </foreignObject>

            {/* Subheading */}
            <foreignObject
              x="0.94"
              y="214.3"
              width="260"
              height="160"
            >
              <div
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  fontFamily: "Proxima Nova Regular, Proxima Nova",
                  fontSize: "20px",
                  color: "black",
                  lineHeight: "1.1",
                  wordWrap: "break-word",
                }}
              >
                {data?.[0]?.subTitle?.split("/n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </div>
            </foreignObject>

            {/* Explore Opportunities Group */}
            <g onClick={() => router(data?.[0]?.buttonUrl)} onMouseEnter={() => setHoveredLetter("N")} onMouseLeave={() => setHoveredLetter(null)} style={{ cursor: "pointer" }}>
              <text
                transform="translate(629.87 129.27)"
                style={{
                  fill: "#aef611",
                  fontFamily: "Proxima Nova Bold, Proxima Nova",
                  fontSize: 18.83,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
                onClick={() => router("/innerpage/newzealand")}
              >
                {data?.[0]?.buttonText}
              </text>

              <path
                d="M797.66,89.74h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23h0c0-18.9-15.32-34.23-34.23-34.23Z"
                fill="none"
                stroke="#aef611"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect
                x="585"
                y="80"
                width="300"
                height="95"
                fill="transparent"
                pointerEvents="all"
              />
            </g>
          </g>
        </svg>


      </div>) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 662.01 173.55"
        >


          {/* Headline */}
          <foreignObject
            x="0.94"
            y="1.67"        // match the y from your <text> transform
            width="500"      // set your desired width
            height="200"     // enough height for all lines
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Black, Proxima Nova",
                fontSize: "38px",        // match your <text> font size
                fontWeight: 800,
                color: data?.[0]?.titleColor,
                lineHeight: "1.05",      // adjust line spacing
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                margin: 0,
                padding: 0,
              }}
            >
              {data?.[0]?.title?.split("/n")}
            </div>
          </foreignObject>

          {/* Description */}
          <foreignObject
            x="0"
            y="90.61"
            width="200"
            height="120"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Regular",
                fontSize: "19px",
                color: "black",
                lineHeight: "1.1",
                wordWrap: "break-word",
              }}
            >
              {data?.[0]?.subTitle?.split("/n").map((line, index) => (
                <div key={index} style={{ lineHeight: "1.05" }}>
                  {line}
                </div>
              ))}
            </div>
          </foreignObject>

          {/* Button */}
          <g transform="translate(-165 45)" onClick={() => router(data?.[0]?.buttonUrl)}>
            <text
              transform="translate(459.25 94.94)"
              style={{
                fontFamily: "Proxima Nova Bold",
                fontSize: "18.83px",
                fontWeight: 700,
                fill: data?.[0]?.buttonColor,
              }}
            >
              {data?.[0]?.buttonText}

            </text>

            <path
              d="M627.03,53.15h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23s-15.32-34.23-34.23-34.23Z"
              style={{
                fill: "none",
                stroke: data?.[0]?.buttonColor,
                strokeWidth: "1.5px",
                strokeLinecap: "round",
                strokeLinejoin: "round",
              }}
            />
          </g>
        </svg>)}

    </>


  );
};

export default Ncomponent;
